import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Form } from "antd";
import dayjs from "dayjs";
import { Breadcrumbs, Button, Link, Typography } from "@material-ui/core";
import useStyles from "./announcementStyle";
import { useTranslation } from "@/langs/useTranslation";
import { useParams } from "react-router-dom";
import {
  getNotificationList,
  handleS3pathDownload
} from "@/apis/announcementApi";
import { useHistory } from "react-router-dom";
import getFileIcon from "@/helpers/fileIcon";
import { notificationColorMap } from "@/components/commons/AppNotificationDetailDialog";

const AnnouncementContent = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation("devicesGroups");
  const { id: announcementId } = useParams();
  const [form] = Form.useForm();

  const [currentInfo, setCurrentInfo] = useState({ json: {} });

  const getInfo = useCallback(async () => {
    // const res = await getAnnouncementInfo({ id: announcementId });
    const res = await getNotificationList(100000, 2);
    const info = res.notificationListObjArr.find(
      item => item.id === announcementId
    ) || { json: {} };

    setCurrentInfo(info);
    form.setFieldsValue({
      ...info,
      startTime: dayjs(Number(info.json.startTime)),
      endTime: dayjs(Number(info.json.endTime)),
      sendTime: dayjs(Number(info.createdAt))
    });
  }, [announcementId, form]);

  const goList = useCallback(() => {
    history.push("/announcement");
  }, [history]);

  const tagTextMap = {
    "Alarm Notification": t({ defaultMessage: "报警通知" }),
    "Platform Notification": t({ defaultMessage: "平台公告" })
  };

  const notificationTag = () => {
    const tagStyle =
      notificationColorMap[currentInfo.json.type] ||
      notificationColorMap["Platform Notification"];
    const tagText =
      tagTextMap[currentInfo.json.type] || tagTextMap["Platform Notification"];

    return (
      <div
        style={{
          padding: "3px 16px",
          fontSize: "12px",
          borderRadius: 12,
          height: 24,
          ...tagStyle
        }}
      >
        {tagText}
      </div>
    );
  };

  const fileList = useMemo(() => {
    try {
      return JSON.parse(currentInfo.json.s3Path || "[]") || [];
    } catch (e) {
      return [];
    }
  }, [currentInfo]);

  useEffect(() => {
    if (announcementId) {
      getInfo();
    }
  }, [getInfo, announcementId]);

  return (
    <div className={classes.root}>
      <main className={classes.announcementContent}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/announcement">
            {t({ defaultMessage: "返回公告列表" })}
          </Link>
          <Typography color="textPrimary">
            {t({ defaultMessage: "查看通知" })}
          </Typography>
        </Breadcrumbs>
        <div className={classes.contentTitleSection}>
          <Typography
            style={{ color: "#33333b", fontSize: 28, fontWeight: 500 }}
          >
            {t({ defaultMessage: "查看通知" })}
          </Typography>
          <Button onClick={goList} color="primary" variant="contained">
            {t({ defaultMessage: "取消" })}
          </Button>
        </div>
        <div className={classes.annContent}>
          <div className={classes.contentSection}>
            <div className={classes.annTitle}>
              <div>{t({ defaultMessage: "通知标题" })}</div>
              {notificationTag()}
            </div>
            <div className={classes.annText}>{currentInfo.json.title}</div>
            <div className={classes.annTitle}>
              {t({ defaultMessage: "通知内容" })}
            </div>
            <div className={classes.annText}>
              <span
                dangerouslySetInnerHTML={{ __html: currentInfo.json.message }}
              />
            </div>
            {currentInfo.json.type === "Platform Notification" && (
              <>
                {Number(currentInfo.json.startTime) ? (
                  <div className={classes.annTime} style={{ marginTop: 24 }}>
                    {t({ defaultMessage: "开始时间" })}:
                    {dayjs(Number(currentInfo.json.startTime)).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}
                  </div>
                ) : null}
                {Number(currentInfo.json.endTime) ? (
                  <div className={classes.annTime}>
                    {t({ defaultMessage: "结束时间" })}:
                    {dayjs(Number(currentInfo.json.endTime)).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}
                  </div>
                ) : null}
              </>
            )}
            {fileList.length > 0 && (
              <div className={classes.annTitle}>
                {t({ defaultMessage: "附件" })}
              </div>
            )}
            {fileList.length > 0 && (
              <div className={classes.fileList}>
                {fileList?.map(file => {
                  const Icon = getFileIcon(file.name);
                  return (
                    <div className={classes.fileItem} key={file.s3Path}>
                      <div
                        style={{ fontSize: 16, marginRight: 10, height: 20 }}
                      >
                        <Icon />
                      </div>
                      <div
                        className={classes.fileItemName}
                        onClick={() => {
                          handleS3pathDownload(file.s3Path);
                        }}
                      >
                        {file.name}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {currentInfo.json.type === "Alarm Notification" ? (
              <Button
                color="primary"
                variant="contained"
                style={{ marginTop: 32, width: 100 }}
                onClick={() => {
                  if (
                    currentInfo.json.deviceSn &&
                    currentInfo.json.deviceOsType
                  ) {
                    window.open(
                      `/device-list/device-detail/${currentInfo.json.deviceSn}/${currentInfo.json.deviceOsType}`
                    );
                  }
                }}
              >
                {t({ defaultMessage: "查询" })}
              </Button>
            ) : null}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AnnouncementContent;
